export default {
  'aboutUs.section1.header': 'OpenDataLab Team',
  'aboutUs.section1.subHeader': 'Building an AI open data ecosystem to fully support large models with data elements.',
  'aboutUs.section1.desc':
    "OpenDataLab, established by the Shanghai AI Lab's large model database team, is the chosen platform for Chinese Large Model Corpus Data Alliance's open data services. It offers comprehensive AI data support to developers, mitigating data processing risks and fostering AI research and applications",

  'aboutUs.section2.header': '活动与合作',
  'aboutUs.section2.knowMore': 'Know More',

  'aboutUs.timeLine.content1': 'OpenDataLab officially launched, open sourcing over 1,000 high-quality datasets.',
  'aboutUs.timeLine.content2':
    'As one of the nine open projects of "Puyuan OpenXLab," it appeared at the World Artificial Intelligence Conference (WAIC) Scientific Frontier Plenary Meeting.',
  'aboutUs.timeLine.content3':
    'The Large Model Corpus Alliance was established, with OpenDataLab designated as its open data platform. The alliance has over 40 members and has released multiple large-scale high-quality datasets.',
  'aboutUs.timeLine.content4':
    'Shusheng · Wanjuan 1.0 was released, with over 2 TB of open source data. The number of download users exceeded 30,000, with over 100,000 downloads, making it a benchmark for domestic pre-training open source corpora.',
  'aboutUs.timeLine.content5':
    'Wanjuan CC releases 400GB of high-quality data, driving BookLife InternLM2 with improved efficiency and performance, leading in overall performance in the open-source community.',

  'aboutUs.section3.desc': 'Pioneers in the field of AI data and advocates for the open data community'
};
